var _path, _path2, _path3, _circle, _circle2, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 128,
    viewBox: "0 2 216 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#465DD8",
    d: "M-22 3h216v168H-22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M-22 3h216v168H-22z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.842 28.19a.719.719 0 1 1-1.437 0 .719.719 0 0 1 1.437 0zM161.438 19.719a.72.72 0 1 1-1.438 0 .72.72 0 0 1 1.438 0zM22.774 97.387a.387.387 0 1 1-.774 0 .387.387 0 0 1 .774 0zM45.63 53.528a.297.297 0 1 1 0-.594.297.297 0 0 1 0 .594z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.907,
    cy: 15.507,
    r: 1,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.407,
    cy: 81.007,
    transform: "rotate(-90 118.407 81.007)",
    fill: "#fff",
    r: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M308 130H-81V49.783a13.36 13.36 0 0 1 1.622-.097c5.06 0 10.486 2.695 12.867 6.227.384.57.717 1.152 1.004 1.744 2.194 4.519 1.753 9.601 1.995 14.46.273 5.495 2.005 11.588 8.172 14.716 4.004 2.032 8.803 2.322 13.771 2.322.955 0 1.915-.011 2.878-.022l.113-.001c1-.012 2.002-.024 3-.024 4.051 0 8.05.19 11.667 1.34 3.746 1.192 6.59 3.223 8.95 5.647 3.052 3.138 5.29 6.932 7.617 10.414 3.931 5.882 10.616 12.103 19.312 12.104.426 0 .855-.015 1.291-.046 14.412-1.011 14.14-11.125 28.61-15.019a20.307 20.307 0 0 1 5.353-.717c2.521 0 4.83.452 7.207.917l.224.044c2.457.48 4.998.96 7.932.96a26.75 26.75 0 0 0 3.865-.28c4.366-4.144 18.799-14.001 41.596-13.711 1.616.244 3.239.362 4.844.362 9.647 0 18.654-4.277 21.79-11.178 3.658-8.047 1.542-16.804 1.861-25.284.32-8.48 4.453-18.08 15.15-21.309 7.033-2.122 15.46-.977 22.141-3.643 16.476-6.573 9.518-28.465 32.786-28.465.24 0 .48.002.726.007 7.062.134 13.791 2.13 20.755 3 1.809.225 3.693.355 5.571.355 5.351 0 10.658-1.054 14.09-3.948 5.452-4.6 4.654-12.545 11.668-15.814 2.203-1.027 4.645-1.348 7.205-1.348 2.112 0 4.304.218 6.512.438l.063.006c2.23.222 4.474.445 6.667.445.447 0 .891-.01 1.332-.03 6.505-.299 12.655-3.299 15.545-7.584 4.246-6.295-2.081-12.934 1.968-18.771H308v172z",
    fill: "#465DD8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveLeft);
export default __webpack_public_path__ + "static/media/WaveLeft.2dd6d660.svg";
export { ForwardRef as ReactComponent };